import type { PortfolioUploadPhoto } from '../model/use-portfolio-upload';
import { PortfolioPhotoItem } from './portfolio-photo-item';
export const PortfolioPhotoList = ({
  photos,
  disabled,
  onMove,
  onRepresentative,
  onRemove,
  onRetry,
  onRefresh,
}: {
  photos: readonly PortfolioUploadPhoto[];
  disabled?: boolean;
  onMove: (from: number, to: number) => void;
  onRepresentative: (id: string) => void;
  onRemove: (id: string) => void;
  onRetry: (id: string) => void;
  onRefresh?: (id: string) => void;
}) => (
  <ul aria-label="사례 사진 순서" className="space-y-3">
    {photos.map((photo, index) => (
      <PortfolioPhotoItem
        key={`${photo.localId}:${photo.previewUrl}`}
        photo={photo}
        index={index}
        count={photos.length}
        disabled={disabled}
        onMove={onMove}
        onRepresentative={onRepresentative}
        onRemove={onRemove}
        onRetry={onRetry}
        onRefresh={onRefresh}
        onDropPhoto={(id, target) => {
          const from = photos.findIndex((value) => value.localId === id);
          if (from >= 0 && from !== target) onMove(from, target);
        }}
      />
    ))}
  </ul>
);
